import { GamesListWidget } from '@namespace/games';
import { useGetVsGameUrl } from './useGetVsGameUrl';

export const VsGamesListWidget = () => {
  const getVsGameUrl = useGetVsGameUrl();

  return <GamesListWidget getGameUrl={getVsGameUrl} isExternal={true} />;
};
